import { render } from "./SettingsTabPayout.vue?vue&type=template&id=852cfbae"
import script from "./SettingsTabPayout.vue?vue&type=script&lang=js"
export * from "./SettingsTabPayout.vue?vue&type=script&lang=js"

import "./SettingsTabPayout.vue?vue&type=style&index=0&id=852cfbae&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__